const SET_EDIT = 'SET_EDIT';
const setEditCall = (edit) => ({
    type: SET_EDIT,
    payload: edit,
});
const initialState = {
    edit: false,
};

const editReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_EDIT:
            return {
                ...state,
                edit: action.payload,
            };
        default:
            return state;
    }
};

export { setEditCall, editReducer };

const SET_EXPLO = 'SET_EXPLO';
const setExPoCall = (edit) => ({
    type: SET_EXPLO,
    payload: edit,
});
const initialState1 = {
    explo: false,
};

const expoReducer = (state = initialState1, action) => {
    switch (action.type) {
        case SET_EXPLO:
            return {
                ...state,
                explo: action.payload,
            };
        default:
            return state;
    }
};

export { setExPoCall, expoReducer };


const SET_INDEX = 'SET_INDEX';
const setIndexCall = (edit) => ({
    type: SET_INDEX,
    payload: edit,
});
const initialState2 = {
    indexCall: null,
};

const indexReducer = (state = initialState2, action) => {
    switch (action.type) {
        case SET_INDEX:
            return {
                ...state,
                indexCall: action.payload,
            };
        default:
            return state;
    }
};

export { setIndexCall, indexReducer };

const SET_CHAT = 'SET_CHAT';
const setChatCall = (edit) => ({
    type: SET_CHAT,
    payload: edit,
});
const initialState3 = {
    chatBot: null,
};

const chatReducer = (state = initialState3, action) => {
    switch (action.type) {
        case SET_CHAT:
            return {
                ...state,
                chatBot: action.payload,
            };
        default:
            return state;
    }
};

export { setChatCall, chatReducer };

const SET_REDIR = 'SET_REDIR';
const setReDirCall = (edit) => ({
    type: SET_REDIR,
    payload: edit,
});
const initialState4 = {
    url: null,
};

const reDirReducer = (state = initialState4, action) => {
    switch (action.type) {
        case SET_REDIR:
            return {
                ...state,
                url: action.payload,
            };
        default:
            return state;
    }
};

export { setReDirCall, reDirReducer };